// extracted by mini-css-extract-plugin
export default {"projects":"styles_projects__9p3pj","projectsDark":"styles_projectsDark__6b1Le","projectsLight":"styles_projectsLight__rppVM"};